import { LogoutIcon } from '@c/icons';
import { PopoverButton } from '@headlessui/react';
import Avatar from '@ui/Avatar';
import useMenuItems from '@util/hooks/useMenuItems';
import { useAuth } from 'context/AuthContext';
import Link from 'next/link';
import BaseMenu from './BaseMenu';

const UserMenu = () => {
  const { userDoc, logout } = useAuth();
  const { accountItems, sellerAccountItems } = useMenuItems(userDoc);
  if (!userDoc) return null;
  return (
    <BaseMenu
      triggerElement={
        <>
          {/* mobile */}
          <div className="flex p-px lg:hidden">
            <div className="p-2">
              <Avatar
                showNotificationCount
                user={userDoc}
                size="extraSmall"
                circle
              />
            </div>
          </div>

          {/* desktop */}
          <div className="hidden p-px lg:flex">
            <div className="p-2">
              <Avatar
                showNotificationCount
                user={userDoc}
                size="extraSmall"
                circle
              />
            </div>
          </div>
        </>
      }
    >
      <div className="isolate flex w-[26rem] flex-col items-start rounded-2xl border-2 bg-brand-white font-medium shadow-lg ">
        <div className="flex w-full flex-col justify-center p-4">
          {!!userDoc.roles?.admin && (
            <PopoverButton as={Link} href="/admin">
              <div className="hover:bg-brand-secondary-80 mb-4 flex h-[5.6rem] cursor-pointer select-none items-center justify-center gap-x-2 whitespace-nowrap rounded-[1.5rem]  bg-brand-secondary  px-[4.4rem] text-[1.5rem] font-semibold text-brand-white transition-colors">
                Admin Dashboard
              </div>
            </PopoverButton>
          )}
          {userDoc.roles?.support ? (
            <PopoverButton as={Link} href="/support">
              <div className=" hover:bg-brand-primary-80 flex h-[5.6rem] cursor-pointer select-none items-center justify-center gap-x-2 whitespace-nowrap rounded-[1.5rem]  bg-brand-primary  px-[4.4rem] text-[1.5rem] font-semibold text-brand-white transition-colors">
                Support Dashboard
              </div>
            </PopoverButton>
          ) : (
            <PopoverButton as={Link} href="/dashboard/my-profile">
              <div className=" hover:bg-brand-primary-80 flex h-[5.6rem] cursor-pointer select-none items-center justify-center gap-x-2 whitespace-nowrap rounded-[1.5rem]  bg-brand-primary  px-[4.4rem] text-[1.5rem] font-semibold text-brand-white transition-colors">
                Account Overview
              </div>
            </PopoverButton>
          )}
        </div>

        <hr className="w-full" />
        <div className="flex w-full flex-col items-start text-brand-black">
          {accountItems.map((item) => (
            <PopoverButton
              key={item.href}
              as={Link}
              href={item.href}
              className="w-full rounded-lg px-[1.5rem] py-4 hover:bg-brand-secondary-light"
            >
              <div className="flex w-full items-center justify-between gap-x-4">
                <div className="flex items-center gap-[1.6rem]">
                  {item.icon}
                  <p>{item.label}</p>
                </div>

                {!!item.badgeCount && (
                  <div className="flex min-h-[1rem] w-fit min-w-[2rem] items-center justify-center rounded-full bg-brand-secondary px-4 py-2 text-[1.2rem] font-medium text-brand-white">
                    {item.badgeCount}
                  </div>
                )}
              </div>
            </PopoverButton>
          ))}
          {userDoc.account_activated && (
            <>
              <hr className="w-full" />
              {sellerAccountItems.map((item) => (
                <PopoverButton
                  key={item.href}
                  as={Link}
                  href={item.href}
                  className="w-full rounded-lg px-[1.5rem] py-4 hover:bg-brand-secondary-light"
                >
                  <div className="flex w-full items-center justify-between gap-x-4">
                    <div className="flex items-center gap-[1.6rem]">
                      {item.icon}
                      <p>{item.label}</p>
                    </div>
                    {!!item.badgeCount && (
                      <div className="flex min-h-[1rem] w-fit min-w-[2rem] items-center justify-center rounded-full bg-brand-secondary px-4 py-2 text-[1.2rem] font-medium text-brand-white">
                        {item.badgeCount}
                      </div>
                    )}
                  </div>
                </PopoverButton>
              ))}
            </>
          )}
        </div>

        <hr className="w-full" />
        <Link
          className="w-full rounded-lg px-[1.5rem] py-4 hover:bg-brand-secondary-light"
          href="/"
          onClick={() => {
            logout();
          }}
        >
          <div className="flex items-center gap-[1.6rem]">
            <LogoutIcon />
            <p>Sign out</p>
          </div>
        </Link>
      </div>
    </BaseMenu>
  );
};

export default UserMenu;
